// Mixpanel event names
export const MIXPANEL_SERVER_EVENT_NAMES = {
  SIGNUP: 'signup',
  REFERRAL_SIGNUP: 'referral_signup',
  REFERRAL_FIRST_PAYMENT: 'referral_first_payment',
  LOGIN: 'login',
  TASK_CREATED: 'task_created',
  CHECKOUT_STARTED: 'checkout_started',
  START_CODING: 'start_coding',
  FINISH_CODING: 'finish_coding',
  CHECKOUT: 'checkout',
  ORDER_SUCCESS: 'order_success',
  SUBSCRIBE_SUCCESS: 'subscribe_success',
  SUBSCRIPTION_RENEWAL: 'subscription_renewal',
  SUBSCRIPTION_CANCELLATION: 'subscription_cancellation',
  SUBSCRIPTION_SCHEDULED_CANCEL: 'subscription_scheduled_cancel',
  SUBSCRIPTION_PAYMENT_FAILED: 'subscription_payment_failed',
  SUBSCRIPTION_DOWNGRADED: 'subscription_downgraded',
  SUBSCRIPTION_SCHEDULED_DOWNGRADE: 'subscription_scheduled_downgrade',
}

export const MIXPANEL_CLIENT_EVENT_NAMES = {
  PAGE_VIEW: 'page_view',
  CLICK_DESIGN_SYSTEM_BUTTON: 'click_design_system_button',
  VERIFY_DOMAIN_SUCCESS: 'verify_domain_success',
  CLICK_SIGNIN: 'click_signin',
  CLICK_VERIFY_CODE: 'click_verify_code',
  CLICK_SIGNUP: 'click_signup',
  CLICK_LOGIN: 'click_login',
  CLICK_LOGOUT: 'click_logout',
  CLICK_PROFILE_MENU: 'click_profile_menu',
  REMIX_PROJECT: 'remix_project',
  CLICK_UNDO_BUTTON_PROJECT_PREVIEW: 'click_undo_button_project_preview',
  CLICK_REDO_BUTTON_PROJECT_PREVIEW: 'click_redo_button_project_preview',
  CLICK_DATABASE_BUTTON_PROJECT_PREVIEW:
    'click_database_button_project_preview',
  CLICK_EDIT_BUTTON_PROJECT_PREVIEW: 'click_edit_button_project_preview',
  CLICK_EXPORT_PROJECT: 'click_export_project',
  CLICK_PROJECT_PROMPT_SUGGESTION: 'click_project_prompt_suggestion',
  CLICK_UPDATE_SCREENSHOT: 'click_update_screenshot',
  PUBLISH_PROJECT: 'publish_project',
  CLICK_ADD_NEW_DOMAIN: 'click_add_new_domain',
  CLICK_USE_TEMPLATE: 'click_use_template',
  UPLOAD_ASSETS: 'upload_assets',
  CLICK_UPLOAD_BUTTON_AI_CHAT: 'click_upload_button_ai_chat',
  CLICK_SELECT_BUTTON_AI_CHAT: 'click_select_button_ai_chat',
  CLICK_EDIT_BUTTON_AI_CHAT: 'click_edit_button_ai_chat',
  CLICK_PLAN_BUTTON_AI_CHAT: 'click_plan_button_ai_chat',
  CLICK_IMPLEMENT_BUTTON_AI_CHAT: 'click_implement_button_ai_chat',
  CLICK_CONTACT_SUPPORT_BUTTON_AI_CHAT: 'click_contact_support_button_ai_chat',
  RESTORE_PROJECT: 'restore_project',
  CLICK_FREE_CREDITS_BUTTON: 'click_free_credits_button',
  CLICK_TOOLBOX_TAB: 'click_toolbox_tab',
  CLICK_EDIT_SAVE_BUTTON_PROJECT_PREVIEW:
    'click_edit_save_button_project_preview',
  CLICK_REMOVE_TARGET_EDITOR: 'click_remove_target_editor',
  CLICK_ENABLE_SEO_BUTTON: 'click_enable_seo_button',
  CLICK_SUBSCRIBE_BUTTON_SEO: 'click_subscribe_button_seo',
  CLICK_PROFILE_MENU_AVATAR: 'click_profile_menu_avatar',
  CLICK_PROFILE_MENU_SUBSCRIPTIONS: 'click_profile_menu_subscriptions',
  CLICK_PROFILE_MENU_CONTACT_SUPPORT: 'click_profile_menu_contact_support',
  CLICK_PROFILE_MENU_HELP_CENTER: 'click_profile_menu_help_center',
  CLICK_PROFILE_MENU_SETTINGS: 'click_profile_menu_settings',
  CLICK_PROFILE_MENU_GIFT_CARD: 'click_profile_menu_gift_card',
  CLICK_ELEMENT_LIBRARY_ASSET: 'click_element_library_asset',
  CLICK_ELEMENT_APP: 'click_element_app',
  CLICK_ELEMENT_LIBRARY_AI_GENERATE: 'click_element_library_ai_generate',
  CLICK_FEATURE_BUTTON: 'click_feature_button',
  WATCH_DEMO: 'watch_demo',
  SUBMIT_PROMPT: 'submit_prompt',
  GENERATE_PROJECT: 'generate_project',
  CLICK_BACK_HOME_DIALOG: 'click_back_home_dialog',
  CLICK_REFERENCE_DESIGN_HOME_PAGE: 'click_reference_design_home_page',
  CLICK_SKIP_HOME_DIALOG: 'click_skip_home_dialog',
  CLICK_START_BUILDING_HOME_DIALOG: 'click_start_building_home_dialog',
  PLAN_PROJECT: 'plan_project',
  SELECT_PROJECT_TYPE_HOME_PAGE: 'select_project_type_home_page',
  UPLOAD_REFERENCE_DESIGN_HOME_PAGE: 'upload_reference_design_home_page',
  INPUT_PROMPT_HOME_PAGE: 'input_prompt_home_page',
  CLICK_START_BUILDING_HOME_PAGE: 'click_start_building_home_page',
  CLOSE_PERSONALIZE_HOME_DIALOG: 'close_personalize_home_dialog',
  SKIP_PERSONALIZE_HOME_PAGE: 'skip_personalize_home_page',
  START_PERSONALIZE_HOME_PAGE: 'start_personalize_home_page',
  VIEW_LATEST_PROJECTS: 'view_latest_projects',
  VIEW_LOGIN_MODAL: 'view_login_modal',
  CLICK_PREVIEW_TEMPLATE_COPY_URL: 'click_preview_template_copy_url',
  CLICK_PREVIEW_TEMPLATE_SWITCH_DESKTOP:
    'click_preview_template_switch_desktop',
  CLICK_PREVIEW_TEMPLATE_SWITCH_MOBILE: 'click_preview_template_switch_mobile',
  CLICK_UPGRADE_PLAN_BUTTON: 'click_upgrade_plan_button',
  CLICK_MANAGE_SUBSCRIPTION_BUTTON: 'click_manage_subscription_button',
  CLICK_ANNUAL_BILLING_SWITCH_BUTTON: 'click_annual_billing_switch_button',
  CLICK_CONNECT_STRIPE_BUTTON: 'click_connect_stripe_button',
  CLICK_SEND_MESSAGE: 'click_send_message',
  CLICK_DOWNLOAD_CODE: 'click_download_code',
  CLICK_CODE_EDITOR: 'click_code_editor',
  PREVIEW_PROJECT: 'preview_project',
  USE_SKILL: 'use_skill',
  CLICK_AUTO_SEO_BUTTON: 'click_auto_seo_button',

  // Annual Upsell Events (for conversion optimization)
  ANNUAL_UPSELL_SHOWN: 'annual_upsell_shown',
  ANNUAL_UPSELL_ACCEPTED: 'annual_upsell_accepted',
  ANNUAL_UPSELL_DISMISSED: 'annual_upsell_dismissed',
  ANNUAL_UPSELL_DUPLICATE_SHOWN: 'annual_upsell_duplicate_shown', // 检测重复显示
  ANNUAL_SUBSCRIPTION_PURCHASED: 'annual_subscription_purchased', // 实际购买
  ANNUAL_UPSELL_INTERACTION: 'annual_upsell_interaction', // 用户交互

  // Mega Annual Upsell Events ($169/year special offer)
  MEGA_ANNUAL_SHOWN: 'mega_annual_shown',
  MEGA_ANNUAL_ACCEPTED: 'mega_annual_accepted',
  MEGA_ANNUAL_DISMISSED: 'mega_annual_dismissed',
  MEGA_ANNUAL_CHECKOUT_STARTED: 'mega_annual_checkout_started',
  MEGA_ANNUAL_PAYMENT_SUCCESS: 'mega_annual_payment_success',
  MEGA_ANNUAL_PAYMENT_FAILED: 'mega_annual_payment_failed',

  // Homepage events
  HOMEPAGE_PAGE_VIEW: 'homepage_page_view',
  CLICK_GENERATE_SITE_BUTTON_HOMEPAGE: 'click_generate_site_button_homepage',
  // Homepage Starter Kit interactions
  CLICK_STARTER_KIT_CARD_HOMEPAGE: 'click_starter_kit_card_homepage',
  CLICK_CLONE_WEBSITE_CARD_HOMEPAGE: 'click_clone_website_card_homepage',
  CLICK_REDESIGN_WEBSITE_CARD_HOMEPAGE: 'click_redesign_website_card_homepage',
  CLICK_EBOOK_GENERATION_CARD_HOMEPAGE: 'click_ebook_generation_card_homepage',

  // QA Planner events
  QA_PLANNER_PAGE_VIEW: 'qa_planner_page_view',

  // QA interaction events
  CLICK_SKIP_STEP_QA: 'click_skip_step_qa',
  CLICK_SKIP_QUESTION_QA: 'click_skip_question_qa',
  CLICK_SAVE_CONTINUE_QA: 'click_save_continue_qa',
  CLICK_START_BUILD_QA: 'click_start_build_qa',

  // Template events
  TEMPLATE_PAGE_VIEW: 'template_page_view',
  CLICK_USE_TEMPLATE_BUTTON: 'click_use_template_button',
  CLICK_PREVIEW_TEMPLATE_TAB: 'click_preview_template_tab',

  // Admin events
  ADMIN_PAGE_VIEW: 'admin_page_view',
  CLICK_ADD_DATA_BUTTON_ADMIN: 'click_add_data_button_admin',
  CLICK_ADD_NEW_RECORD_ADMIN: 'click_add_new_record_admin',
  CLICK_ADVANCED_SETTINGS_ADMIN: 'click_advanced_settings_admin',
  CLICK_ADD_COLUMN_ADMIN: 'click_add_column_admin',

  // SEO events
  CLICK_AUTO_SEO_SAVE_BUTTON: 'click_auto_seo_save_button',

  // AI Team Photo events
  AI_TEAM_PHOTO_GENERATE_SUCCESS: 'ai_team_photo_generate_success',
  AI_TEAM_PHOTO_DOWNLOAD: 'ai_team_photo_download',
  AI_TEAM_PHOTO_SHARE_TWITTER: 'ai_team_photo_share_twitter',
  AI_TEAM_PHOTO_SHARE_LINKEDIN: 'ai_team_photo_share_linkedin',

  // Onboarding survey events
  VIEW_ONBOARDING_SURVEY_MODAL: 'view_onboarding_survey_modal',
  SUBMIT_ONBOARDING_SURVEY: 'submit_onboarding_survey',
  DISMISS_ONBOARDING_SURVEY: 'dismiss_onboarding_survey',

  // Discord modal single unified event
  USER_DISCORD_POPUP: 'user_discord_popup',

  // Affiliate icon click (single unified event)
  USER_AFFILIATE_ICON: 'user_affiliate_icon',
  USER_AFFILIATE_CTA_CLICK: 'user_affiliate_cta_click',

  // Visual editing tutorial events
  VIEW_VISUAL_EDITING_TUTORIAL: 'view_visual_editing_tutorial',
  CLOSE_VISUAL_EDITING_TUTORIAL: 'close_visual_editing_tutorial',
  PLAY_VISUAL_EDITING_TUTORIAL_VIDEO: 'play_visual_editing_tutorial_video',
  CLICK_ENHANCE_PROMPT_BUTTON: 'click_enhance_prompt_button',
  SUBMIT_PROMPT_FEEDBACK: 'submit_prompt_feedback',
  CLICK_SUPER_PROMPTS_BUTTON: 'click_super_prompts_button',
  OPEN_ELEMENT_LIBRARY_FROM_CHAT: 'open_element_library_from_chat',
  PROJECT_GENERATION_FAILED: 'project_generation_failed',
  VIEW_GENERATED_PROJECT: 'view_generated_project',
  PROJECT_DOMAIN_BINDING_START: 'project_domain_binding_start',
  PROJECT_DOMAIN_BINDING_SUCCESS: 'project_domain_binding_success',
  PROJECT_DOMAIN_PUBLISH_SUCCESS: 'project_domain_publish_success',
  PROJECT_DOMAIN_UNBINDING: 'project_domain_unbinding',
  PROJECT_GENERATION_CONFIRMED: 'project_generation_confirmed',
  PAYWALL_TRIGGERED: 'paywall_triggered',
  PRICING_PAGE_VIEWED: 'pricing_page_viewed',
  PLAN_SELECTED: 'plan_selected',
  VIEW_COMPLETED_PROJECT: 'view_completed_project',
  PROJECT_COMPLETION_PROMPT_VIEWED: 'project_completion_prompt_viewed',
  PROJECT_COMPLETION_PROMPT_CLICKED: 'project_completion_prompt_clicked',
  PROJECT_COMPLETION_PROMPT_DISMISSED: 'project_completion_prompt_dismissed',
  NOTIFICATION_PERMISSION_REQUESTED: 'notification_permission_requested',
  NOTIFICATION_PERMISSION_GRANTED: 'notification_permission_granted',
  NOTIFICATION_PERMISSION_DENIED: 'notification_permission_denied',
  PROJECT_COMPLETION_NOTIFICATION_ENABLED:
    'project_completion_notification_enabled',
  PROJECT_COMPLETION_NOTIFICATION_DISABLED:
    'project_completion_notification_disabled',
}
